import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const movementIconStyles = styleVariants({
  up: {
    color: vars.colors.onSuccess,
    fill: vars.colors.success,
  },
  down: {
    transform: "rotate(180deg)",
    color: vars.colors.onError,
    fill: vars.colors.error,
  },
  same: {
    color: vars.colors.outline,
    fill: vars.colors.outline,
  },
});

export const newIconStyles = style({ fill: vars.colors.primary });

export const movementIconContainer = style({
  display: "inline-block",
  width: 16,
  height: 16,
  verticalAlign: "middle",
});
